import Cookies from 'js-cookie';

import { API_URL } from 'config/app.endpoints';

type RequestBody = Record<string, unknown>;

export const fetchWithCsrfToken = async <Response>(
  url: string,
  method?: string,
  body?: RequestBody | FormData
): Promise<Response> => {
  const requestInit: RequestInit = {
    credentials: 'include',
    headers: {
      'X-CSRFToken': extractCsrfTokenFromCookies(),
    },
    method,
    body: body ? JSON.stringify(body) : null,
  };
  return wrapFetchFunction(url, requestInit);
};

export const fetchWithCsrfTokenFormData = async <Response>(
  url: string,
  method?: string,
  body?: FormData
): Promise<Response> => {
  const requestInit: RequestInit = {
    credentials: 'include',
    headers: {
      'X-CSRFToken': extractCsrfTokenFromCookies(),
    },
    method,
    body,
  };

  return wrapFetchFunction(url, requestInit);
};

export const fetchWithoutCsrfToken = async (
  url: string,
  method?: string,
  body?: RequestBody
) => {
  const requestInit: RequestInit = {
    method,
    body: body ? JSON.stringify(body) : null,
    mode: 'cors',
  };

  return wrapFetchFunction(url, requestInit);
};

const wrapFetchFunction = async (url: string, requestInit: RequestInit) => {
  const response = await fetch(`${API_URL}/${url}`, requestInit);
  if (!response.ok) {
    const error = await response.json().catch(() => response.statusText);
    if (response.status === 403 || error.error === 'User not authenticated') {
      // Redirect to login page
      window.location.href = `${API_URL}`;
    }

    throw new Error(error?.error || error?.errors || response.statusText, {
      cause: { status: response.status },
    });
  }

  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

const extractCsrfTokenFromCookies = () => {
  const csrfTokenCookie = Cookies.get('csrftoken');
  if (!csrfTokenCookie) {
    throw new Error('CSRF token cookie not found');
  }
  return csrfTokenCookie;
};
